var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<fieldset class="captcha-image">\n    <img src="'+
((__t=( data.captcha_url ))==null?'':__t)+
'" />\n</fieldset>\n<fieldset class="captcha-text"></fieldset>\n';
return __p;
};
